import { useAccountState } from 'contexts/account/account-context';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { isNullOrUndefined } from 'utils/empty-or-null';
import { useSitesState } from 'views/order-feed/context/sites-context';
import { MySupplyPlanParams } from 'views/order-feed/features/my-supply-plan/types/my-supply-plan-params.type';

export const useSelectedSite = () => {
  const {
    account: { company },
  } = useAccountState();

  const params = useParams<MySupplyPlanParams>();
  const {
    sitesQuery: { data: sites },
  } = useSitesState();

  const selectedSite = useMemo(() => {
    return sites?.find((site) => site.globalSiteId === params.globalSiteId);
  }, [params.globalSiteId, sites]);

  const selectedSiteId = useMemo(() => {
    if (isNullOrUndefined(params.globalSiteId)) return '';
    else return `${params.siteErpId}/${params.globalSiteId}`;
  }, [params]);

  return { selectedSiteId, selectedSite };
};
